import React from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { useFela } from 'react-fela';
import { Row, Spacer } from '../common';
import {
  formatHHMM,
  formatHhMmSs,
} from '../utils';
import ClockIcon from './ClockIcon';

const containerRules = () => ({
  position: 'absolute',
  bottom: '0',
  left: '0',
  right: '0',
  top: '0',
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'center',
});

const labelRules = ({ theme }) => ({
  color: theme.color.light,
  fontSize: theme.fontSize.medium,
  fontWeight: 'bold',
  padding: `${theme.margin.fine} ${theme.margin.medium}`,
  background: theme.color.overlayDarkFaint,
});

function SeekOverlay() {
  const {
    isLive,
    currentTime,
    viewableMetadata,
    seekingTime,
    seekMode,
  } = useSelector(({ playback, controls }) => ({
    isLive: playback.isLive,
    currentTime: playback.currentTime,
    viewableMetadata: playback.viewableMetadata,
    seekingTime: controls.seekingTime,
    seekMode: controls.seekMode,
  }), shallowEqual);

  const { css } = useFela();

  if (!isLive || !seekMode) {
    return null;
  }

  return (
    <div className={css(containerRules)}>
      <div className={css(labelRules)}>
        {(viewableMetadata.start || viewableMetadata.stop) ? (
          <Row alignCenter>
            <ClockIcon currentTime={seekingTime} />

            <Spacer width="10px" />

            {formatHHMM(seekingTime)}
          </Row>
        ) : (
          formatHhMmSs(seekingTime - currentTime)
        )}
      </div>
    </div>
  );
}

export default React.memo(SeekOverlay);
